<template>
  <v-card height="100%" class="grow flex flex-col border-theme" variant="flat" rounded="lg">
    <div class="px-6 pt-6">
      <div class="text-sm font-bold">{{ title }}</div>
      <slot name="subtitle"></slot>
    </div>
    <slot></slot>
  </v-card>
</template>

<script lang="ts" setup>
defineProps<{
  title: string;
}>();
</script>
